import { observer } from 'mobx-react';
import { FC, ReactElement } from 'react';
import preparationProfilesStore from '../../store/preparationProfilesStore';
import { IPreparationProfile, TPreparationProfileRadios } from '../../types/preparationProfiles';
import { Checkbox } from '~/view/components/Controls/Checkbox/Checkbox';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';
import Text, { TEXT } from '~/view/components/Text/Text';

interface IProps {
  title: string;
  options: IPickerOption[];
  field: TPreparationProfileRadios;
}

export const PreparationOrderSettingsRadios: FC<IProps> = observer((props: IProps): ReactElement => {
  const changeUnit = (field: TPreparationProfileRadios) => (value: string | number) => {
    const newData: Partial<IPreparationProfile> = { [field]: value };
    if (field === 'preOrderPeriodUnit') newData.preOrderPeriod = undefined;

    preparationProfilesStore.changeSelectedProfile(newData);
  };

  return (
    <div className="d-flex flex-column gap-20">
      <Text text={props.title} type={TEXT.BLOCK_HEADER} />
      <div className="d-flex flex-row flex-wrap gap-20">
        {props.options.map((option) => (
          <Checkbox
            key={option.value}
            type="radio"
            name={option.value}
            value={preparationProfilesStore.selectedProfile[props.field] === option.value}
            label={option.label}
            onClick={changeUnit(props.field)}
          />
        ))}
      </div>
    </div>
  );
});
